import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Navigate, useNavigate} from "react-router-dom";
import axios from "axios";
import {userCan} from "../Components/Helpers/Utils";
import {errorAlert} from "../Components/Alerts/BasicAlert";

const canAccess = (useRoles, accessRoles) => {
  if (!accessRoles) return true;
  return useRoles.some(r => accessRoles.includes(r));
}

export default function ProtectedRoute({Component, accessRoles, permission=null, ...props}) {
  const user = useSelector(state => state.user);
  const [loaded, setLoaded] = useState(false);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (403 === error.response.status) {
      errorAlert(error.response.data?.message)
      // navigate('/forbidden')
    } else {
      return Promise.reject(error);
    }
  });

  useEffect(() => {
    axios.get('admins/auth-admin-info').then(res => {
      dispatch({type: 'PUT_USER', user: res.data.admin});
    }).catch(err => {
      dispatch({type: 'PUT_USER', user: null});
    }).finally(() => setLoaded(true));
  }, []);

  if (!loaded) return null;

  if (user && user.email) {
    return (canAccess(user?.roles, accessRoles) && userCan(user?.permissions, permission))
      ? <Component {...props} /> : <Navigate to="/forbidden"/>
  } else {
    return (
      <Navigate to="/login"/>
    )
  }
}
